import { TCodec } from "../codec";
import { either } from "fp-ts/lib";
import { TError, errorConstants } from "../errors";

export type TAnyIntegerFromStringCodec = TCodec<
    "IntegerFromStringCodec",
    undefined,
    number,
    number
>;

const decode = (input: unknown): either.Either<TError, number> =>
    typeof input === "string"
    && isNaN(Number.parseFloat(input)) === false && Number.isInteger(Number.parseFloat(input))
        ? either.right(Number.parseInt(input))
        : either.left([[errorConstants.INTEGER_VALIDATION, ""]]);

export const integerFromString = (): TAnyIntegerFromStringCodec => ({
    type: "IntegerFromStringCodec",
    payload: undefined,
    decode,
    decodeNewDefault: decode,
    newDefault: () => 0,
});
